import { InstitutionRequest } from './usePlaidInstitutionById.interface';

import collectiveApi from 'modules/common/collectiveApi';

const fetchPlaidInstitutionById = async (institutionId: string) => {
    const { data } = await collectiveApi.post<InstitutionRequest>('plaid/institutions/get_by_id/', {
        institution_id: institutionId,
        country_codes: ['US'],
        options: {
            include_optional_metadata: true,
        },
    });

    if (data.institution) {
        return data.institution;
    }

    return undefined;
};

export default fetchPlaidInstitutionById;
